/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React from "react";
import Navbar from "react-bootstrap/Navbar";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { SignInButton } from "./SignInButton";
import { SignOutButton } from "./SignOutButton";
import User from "./User";
import "../index.css";
import novaspaceLogo from "../../src/assets/nova-logo.svg";
import TitleTool from "../components/TitleTool";

/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props
 */
export const PageLayout = (props) => {
  const isAuthenticated = useIsAuthenticated();
  const { instance, accounts } = useMsal();
  return (
    <>
      <Navbar className="navbar sticky-nav">
        <div className="logo-tool">
          <img src={novaspaceLogo} alt="novaspace logo" className="logo" />
          <TitleTool />
        </div>
        <div className="user-info">
          <div className="user-account">
            {accounts[0] ? (
              <User name={accounts[0].name} email={accounts[0].username} />
            ) : (
              <></>
            )}
          </div>
          <div className="sign-out">
            {isAuthenticated ? <SignOutButton /> : <SignInButton />}
          </div>
        </div>
      </Navbar>

      {props.children}
    </>
  );
};
